export var FolderableType;
(function (FolderableType) {
    FolderableType["CUSTOM_PDF_REPORT"] = "custom_pdf_report";
    FolderableType["CUSTOM_SECURITY"] = "custom_security";
    FolderableType["EMAIL_REPORTS"] = "custom_email_report";
    FolderableType["FOLDER"] = "folder";
    FolderableType["FUND_CHART"] = "saved_fundamental_chart";
    FolderableType["FUND_SCREENER"] = "fund_screen";
    FolderableType["PORTFOLIO_OPTIMIZER"] = "portfolio_optimizer";
    FolderableType["MODEL_PORTFOLIO"] = "model_portfolio";
    FolderableType["STOCK_SCREENER"] = "comp_screen";
    FolderableType["TALKING_POINTS"] = "user_talking_point";
    FolderableType["WATCHLIST"] = "watchlist";
    FolderableType["HYPOTHETICAL"] = "hypothetical";
})(FolderableType || (FolderableType = {}));
